var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M317.794,450.216V353.11H194.205v97.105h-31.774c-3.542,0-4.864,4.645-1.853,6.509l84.015,52.029 c6.989,4.328,15.825,4.328,22.814,0l84.015-52.029c3.011-1.865,1.691-6.509-1.853-6.509H317.794z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.211,
    y: 353.11,
    style: {
      fill: "#D2555A"
    },
    width: 123.589,
    height: 35.311
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707487"
    },
    d: "M423.727,370.766H88.272c-9.751,0-17.656-7.904-17.656-17.656V17.656C70.617,7.904,78.521,0,88.272,0 h280.344c7.024,0,13.759,2.79,18.726,7.756l46.283,46.281c4.967,4.967,7.757,11.703,7.757,18.727V353.11 C441.383,362.862,433.478,370.766,423.727,370.766z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M397.244,370.766H114.756V176.555c0-9.751,7.904-17.656,17.656-17.656h247.177 c9.751,0,17.655,7.904,17.655,17.656V370.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M335.45,123.589H132.411c-9.751,0-17.656-7.904-17.656-17.656V0h238.349v105.933 C353.105,115.684,345.201,123.589,335.45,123.589z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7DEED"
    },
    d: "M211.861,123.589H335.45c9.751,0,17.656-7.904,17.656-17.656V0h-158.9v105.933 C194.205,115.684,202.111,123.589,211.861,123.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B5D6E"
    },
    d: "M326.622,105.933h-35.311c-4.875,0-8.828-3.953-8.828-8.828V26.483c0-4.875,3.953-8.828,8.828-8.828 h35.311c4.875,0,8.828,3.953,8.828,8.828v70.622C335.45,101.98,331.498,105.933,326.622,105.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFF2FA"
    },
    d: "M370.761,353.11H141.239c-4.875,0-8.828-3.953-8.828-8.828v-158.9c0-4.875,3.953-8.828,8.828-8.828 h229.522c4.875,0,8.828,3.953,8.828,8.828v158.9C379.588,349.158,375.637,353.11,370.761,353.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6464"
    },
    d: "M370.761,353.11H141.239c-4.875,0-8.828-3.953-8.828-8.828v-17.656c0-4.875,3.953-8.828,8.828-8.828 h229.522c4.875,0,8.828,3.953,8.828,8.828v17.656C379.588,349.158,375.637,353.11,370.761,353.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ABAF"
    },
    d: "M353.105,291.316H158.894c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 h194.211c4.875,0,8.828,3.953,8.828,8.828l0,0C361.933,287.363,357.981,291.316,353.105,291.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ABAF"
    },
    d: "M353.105,256.005H158.894c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 h194.211c4.875,0,8.828,3.953,8.828,8.828l0,0C361.933,252.052,357.981,256.005,353.105,256.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7ABAF"
    },
    d: "M353.105,220.694H158.894c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 h194.211c4.875,0,8.828,3.953,8.828,8.828l0,0C361.933,216.741,357.981,220.694,353.105,220.694z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/backup.35548b00a970707e7c24061494beb84c.svg";
export { ForwardRef as ReactComponent };